import { SEND_SALES_EVENT } from './actionTypes/sales';
import type { EventMeta } from './backendEventLogger';
import { logSalesEvent } from './backendEventLogger';

interface SalesEventItem {
    category: string;
    product: string;
    amount: number;
}

interface SalesEventMeta extends EventMeta {
    campaign: string;
    items: SalesEventItem[];
    customer_ref: string;
}

interface SendSalesEventPayload {
    eventType: string;
    callId: string | null;
    meta: SalesEventMeta;
}

type DispatchFn = (action: unknown) => unknown;

export const sendSalesEvent = (payload: SendSalesEventPayload) => (dispatch: DispatchFn) => {
    dispatch({
        type: SEND_SALES_EVENT,
        payload
    });
    dispatch(logSalesEvent(payload.eventType, payload.callId, payload.meta));
};
